import React, { useRef, useState } from "react";
import "./EmailInvoice.css";
import { Button } from "primereact/button";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Toast } from "primereact/toast";
import CommonLoaderBlue from "../../../../../../../../../../components/Loader/LoaderBlue";
import {
  InvoiceRemainderIcon,
  InvoiceSentSuccessIcon,
} from "../../assets/Assets";
import DownloadInvoiceTemplate from "./components/DownloadInvoiceTemplate";
export const MailInvoice = ({
  setSelectedAction,
  cpData,
  currentInvoice,
  setCurrentActiveDialog,
}) => {
  let toast = useRef();
  const [invoiceData, setInvoiceData] = useState();
  const LoginRes = JSON.parse(localStorage.getItem("userData"));
  const [isSendEmail, setIsSendEmail] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const validationSchema = Yup.object().shape({
    //reason: Yup.string().required("Field Is Required"),
  });
  const [isSendSuccessfully, setIsSendSuccessfully] = useState(false);
  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      reason: "",
      customerId: cpData?._id,
      userId: LoginRes?._id,
      invoiceId: currentInvoice?._id,
      invoiceVoid: true,
    },
    onSubmit: async (values, { resetForm }) => {
      setIsLoading(true);
      setInvoiceData(currentInvoice);
      setIsSendEmail(true);
    },
  });
  return (
    <>
      <div
        style={{
          position: "fixed",
          zIndex: 9999,
          width: "100vw",
          height: "100vh",
          backgroundColor: "#FFFFFF99",
          top: 0,
          left: 0,
        }}
      ></div>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          formik.handleSubmit();
        }}
        id="mail-invoice-container"
        className="sendmail-invoice-container flex flex-wrap flex-row justify-content-center"
      >
        <div
          style={{ height: !isSendSuccessfully ? "35.6rem" : "34.8rem" }}
          className="main-sendmail-invoice"
        >
          <div
            style={{
              gap: !isSendSuccessfully ? "1.4rem" : "3.2rem",
              height: !isSendSuccessfully ? "17.8rem" : "17rem",
            }}
            className="invoice-remainder-info"
          >
            <div className="remainder-icon">
              {!isSendSuccessfully ? (
                <InvoiceRemainderIcon />
              ) : (
                <InvoiceSentSuccessIcon />
              )}
            </div>
            <div
              style={{ height: !isSendSuccessfully ? "9.2rem" : "6.6rem" }}
              className="customer-remainder-info"
            >
              <h1>
                {!isSendSuccessfully
                  ? "Send Invoice Remainder"
                  : "Invoice Sent Successfully"}
              </h1>
              <p>
                {!isSendSuccessfully ? (
                  <>
                    A payment reminder for Invoice{" "}
                    <span>{currentInvoice?.invoiceNo}</span>, Amount:{" "}
                    <span>${currentInvoice?.currentBalance}</span> will be sent
                    to:{" "}
                    <span>
                      {cpData?.firstName}
                      {cpData?.lastName ? ` ${cpData.lastName}` : ""}
                    </span>{" "}
                    at <span>{cpData?.email}</span>.
                  </>
                ) : (
                  "The invoice has been sent to the customer"
                )}
              </p>
            </div>
          </div>
          <div className="action-buttons flex flex-wrap flex-row justify-content-center aligbn-item-center">
            {!isSendSuccessfully && (
              <>
                {" "}
                <Button
                  disabled={isLoading}
                  className="back-button"
                  onClick={() => {
                    setSelectedAction("");
                    setCurrentActiveDialog({
                      void: false,
                      lateFee: false,
                      adjustInvoice: false,
                      download: false,
                      sendEmail: false,
                    });
                  }}
                  label="Back"
                />
                <Button
                  type="submit"
                  label={
                    isLoading ? (
                      <div className="flex flex-wrap flex-row justify-content-center align-items-center">
                        <CommonLoaderBlue sizehere="12" color="white" />{" "}
                      </div>
                    ) : (
                      "Send"
                    )
                  }
                />{" "}
              </>
            )}
            {isSendSuccessfully && (
              <Button
                className="close-button"
                disabled={isLoading}
                onClick={() => {
                  setSelectedAction("");
                  setCurrentActiveDialog({
                    void: false,
                    lateFee: false,
                    adjustInvoice: false,
                    download: false,
                    sendEmail: false,
                  });
                }}
                label="Close"
              />
            )}
          </div>
        </div>
        <Toast ref={toast} />
      </form>
      {invoiceData !== undefined && isSendEmail && invoiceData !== null && (
        <DownloadInvoiceTemplate
          setIsSendEmail={setIsSendEmail}
          setIsSendSuccessfully={setIsSendSuccessfully}
          setIsLoading={setIsLoading}
          toast={toast}
          userDetails={cpData}
          invoiceData={invoiceData}
        />
      )}
    </>
  );
};
